export default {
  actions: {
    setUserInfo({ commit }, info) {
      commit('SETUSERINFO', info);
    },
  },
  mutations: {
    SETUSERINFO(state, info) {
      state.userInfo = info;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js